import React from 'react';
import { Link } from 'react-router-dom';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const footerSections = [{
    title: 'Product',
    links: [{
      name: 'Features',
      href: '#features'
    }, {
      name: 'Use Cases',
      href: '#use-cases'
    }, {
      name: 'Pricing',
      href: '#pricing'
    }]
  }, {
    title: 'Resources',
    links: [{
      name: 'FAQ',
      href: '#faq'
    }, {
      name: 'Contact',
      href: 'mailto:support@fluid-form.ai'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Terms of Use',
      href: '/terms',
      isRouterLink: true
    }, {
      name: 'Privacy Policy',
      href: '/privacy',
      isRouterLink: true
    }]
  }];
  return <footer className="w-full bg-gray-800 text-white py-12" data-id="element-90">
      <div className="container mx-auto px-4" data-id="element-91">
        <div className="flex flex-col md:flex-row justify-between" data-id="element-92">
          <div className="mb-8 md:mb-0" data-id="element-93">
            <Link to="/" data-id="element-94">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KuE4GiXagr4eVmupSGvce/fluid-form-logo.png" alt="FluidForm Logo" className="h-8 mb-4 brightness-200" data-id="element-95" />
            </Link>
            <p className="text-gray-400 max-w-sm" data-id="element-96">
              Build forms that think, speak, and adapt across all platforms.
            </p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-97">
            {footerSections.map((section, index) => <div key={index} data-id="element-98">
                <h3 className="text-lg font-medium mb-4" data-id="element-99">{section.title}</h3>
                <ul className="space-y-2" data-id="element-100">
                  {section.links.map((link, linkIndex) => <li key={linkIndex} data-id="element-101">
                      {link.isRouterLink ? <Link to={link.href} className="text-gray-400 hover:text-white transition-colors" data-id="element-102">
                          {link.name}
                        </Link> : <a href={link.href} className="text-gray-400 hover:text-white transition-colors" data-id="element-103">
                          {link.name}
                        </a>}
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400" data-id="element-104">
          <p data-id="element-105">© {currentYear} FluidForm. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;